<script setup lang="ts">
const open = ref(false)
const { $trackEvent } = useNuxtApp()
const { workspaceId } = useAuth()

const { feature } = defineProps<{
  feature: UpsellFeature
}>()

const { hasFeatureAccess, isFeatureHidden, showUpsell } =
  useFeatureAccess(feature)

function openDialog() {
  $trackEvent("upsell_feature_clicked", {
    workspace_id: workspaceId.value,
    feature_name: feature,
  })
  open.value = true
}
</script>
<template>
  <div
    v-if="!isFeatureHidden"
    :class="!hasFeatureAccess && showUpsell ? 'group relative' : 'relative'"
  >
    <div
      :aria-hidden="!hasFeatureAccess && showUpsell ? 'true' : undefined"
      :class="
        !hasFeatureAccess && showUpsell
          ? 'pointer-events-none opacity-40'
          : undefined
      "
      :inert="(!hasFeatureAccess && showUpsell) || undefined"
    >
      <slot />
    </div>
    <template v-if="!hasFeatureAccess && showUpsell">
      <div
        class="pointer-events-none absolute inset-y-0 right-2 flex items-center"
      >
        <SvgoPikaLock class="size-4.5 opacity-40" />
      </div>
      <button
        type="button"
        class="absolute inset-0 cursor-pointer rounded-lg transition-colors hover:bg-zinc-950/3 focus:outline-hidden"
        @click="openDialog"
      />
    </template>
  </div>
  <FeatureUpsellDialog
    v-if="!isFeatureHidden && !hasFeatureAccess && showUpsell"
    v-model:open="open"
    :feature
  />
</template>
